export {default as InformationalSection} from './InformationalSection'



// WEBPACK FOOTER //
// ./src/components/sections/index.js